import React from 'react';
import style from '../css/Gallery.module.css';

import img1 from '../images/gallery/img1.png';
import img2 from '../images/gallery/img2.png';
import img3 from '../images/gallery/img3.png';
import img4 from '../images/gallery/img4.png';

import videoVertical from '../images/gallery/video_vertical.mp4';

const Gallery = () => {
	return (
		<section className={style.mainSection}>
			<div className={style.mainContainer}>
				<div className={style.bubble}>
					<span>Se parte de la comunidad LIBEL</span>
				</div>

				<h1>RESULTADOS DE ALUMNOS</h1>
				<div className={style.grid}>
					<div className={style.gallery1}>
						<img src={img1} alt='1' />
						{/* <video src={video1} autoPlay loop muted playsInline alt='1'></video> */}
						<div className={style.alumno1}>
							<h1>Alumn@: Fabrizzio Valladares Aguilar.</h1>
						</div>
					</div>
					<div className={style.gallery2}>
						<img src={img2} alt='2' />
						<div className={style.alumno2}>
							<h1>Alumn@: Juan Guerra.</h1>
						</div>
					</div>
					<div className={style.gallery3}>
						<video src={videoVertical} autoPlay loop muted playsInline alt='vertical'></video>
						<div className={style.alumno3}>
							<h1>Alumn@: bryan nuncira.</h1>
						</div>
					</div>
					<div className={style.gallery4}>
						<img src={img3} alt='3' />

						<div className={style.alumno4}>
							<h1>Alumn@: Emilia Cervantes.</h1>
						</div>
					</div>
					<div className={style.gallery5}>
						{/* <video src={video2} autoPlay loop muted playsInline alt='2'></video> */}
						<img src={img4} alt='4' />

						<div className={style.alumno5}>
							<h1>Alumn@: Fabrizzio Valladares Aguilar.</h1>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Gallery;
